module.exports = __webpack_public_path__ + "static/wpack/extracted/students_template377f4567d177bbcd5871bdbf0f851a86.csv";